import { Component } from '@angular/core';
import { PropertiesService } from '../../entities/saisine/properties.service';

@Component({
    selector: 'jhi-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.scss']
})
export class FooterComponent {
    constructor(public propertiesService: PropertiesService) { }
}




// WEBPACK FOOTER //
// ./src/main/webapp/app/layouts/footer/footer.component.ts